import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import SearchSortType from '../../../../utility/types/SearchSortType';
import {
  selectSavedSearches,
} from '../../../../redux/slices/savedSearchesSlice/savedSearchesSlice';

const FILTER_MODES = [
  { value: 'ALL', label: 'All' },
  { value: 'FAVORITED', label: 'Favorited' },
  { value: 'TRIGGERED', label: 'Triggered' },
  { value: 'SAVED_SEARCH', label: 'Saved Searches' },
];

export const ALERTS_LIST_DEFAULT_CONTEXT = {
  filter: 'ALL',
  savedSearchId: null,
  currentPage: 0,
  rowsPerPage: 10,
  sortType: SearchSortType.ALERT_NAME,
  sort: 'DES',
};

const PAGING_RESET = {
  currentPage: 0,
  rowsPerPage: 10,
};

const AlertsListWidgetEdit = ({ context, onChange, errors }) => {
  const {
    filter = 'ALL',
    savedSearchId = null,
  } = context;

  const savedSearches = useSelector(selectSavedSearches);
  const selectedSavedSearchId = savedSearchId != null ? String(savedSearchId) : '';

  useEffect(() => {
    if (!context.filter || !context.sortType || !context.sort) {
      onChange({
        ...ALERTS_LIST_DEFAULT_CONTEXT,
        ...context,
        filter: context.filter || ALERTS_LIST_DEFAULT_CONTEXT.filter,
        sortType: context.sortType || ALERTS_LIST_DEFAULT_CONTEXT.sortType,
        sort: context.sort || ALERTS_LIST_DEFAULT_CONTEXT.sort,
      });
    }
  }, []);

  const handleFilterChange = (e) => {
    const next = e.target.value;
    onChange({
      ...context,
      filter: next,
      savedSearchId: next === 'SAVED_SEARCH' ? savedSearchId : null,
      ...PAGING_RESET,
    });
  };

  const handleSavedSearchChange = (e) => {
    const { value } = e.target;
    onChange({
      ...context,
      savedSearchId: value ? Number(value) : null,
      ...PAGING_RESET,
    });
  };

  return (
    <FormErrorHandler errorList={errors} noDivTags>
      <Form.Group>
        <Form.Label column>Alert Filter</Form.Label>
        <Form.Control as="select" value={filter} onChange={handleFilterChange}>
          {FILTER_MODES.map((m) => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </Form.Control>
      </Form.Group>

      {filter === 'SAVED_SEARCH' && (
        <Form.Group>
          <Form.Label column>Saved Search</Form.Label>
          {savedSearches.length === 0 ? (
            <div className="text-muted small">No saved searches available.</div>
          ) : (
            <Form.Control
              as="select"
              value={selectedSavedSearchId}
              onChange={handleSavedSearchChange}
            >
              <option disabled value="">Select a saved search...</option>
              {savedSearches.map((s) => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </Form.Control>
          )}
          {!selectedSavedSearchId && (
            <Form.Text className="text-danger">
              Must select a saved search.
            </Form.Text>
          )}
        </Form.Group>
      )}
    </FormErrorHandler>
  );
};

AlertsListWidgetEdit.propTypes = {
  context: PropTypes.shape({
    filter: PropTypes.string,
    savedSearchId: PropTypes.number,
    disabledColumns: PropTypes.arrayOf(PropTypes.string),
    currentPage: PropTypes.number,
    rowsPerPage: PropTypes.number,
    sortType: PropTypes.number,
    sort: PropTypes.oneOf(['ASC', 'DES']),
  }),
  errors: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    message: PropTypes.string,
    code: PropTypes.string,
  })),
  onChange: PropTypes.func,
};

AlertsListWidgetEdit.defaultProps = {
  context: {},
  onChange: () => {},
  errors: [],
};

export default AlertsListWidgetEdit;
